export default __webpack_public_path__ + "static/media/me_background.558d0ef8.png";